/* eslint-disable import/no-default-export */
import { mallApiDomain, mallDomain } from '@/defines/domains'
import { request } from '../request'

export const mallApi = {
  async post(path, data) {
    try {
      const url = `${mallApiDomain}/api${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export const mallDomainApi = {
  async post(path, data) {
    try {
      const url = `${mallDomain}/mall/api${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export const mallFeDomainApi = {
  async post(path, data) {
    try {
      const url = `${mallDomain}/mall-fe/api/${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export const mallEntranceDomainApi = {
  async post(path, data) {
    try {
      const url = `${mallDomain}/mall-entrance/api/${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
